// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.termination.LeaseTerminationWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { GetTerminationReasonsResponseDto, TerminateLeaseRequestDto } from '../..';

export const LeaseTerminationWebApiHandler_getTerminationReasons_Path = '/api/web/v1/termination/getTerminationReasons';

/**
 * get termination reasons
 */
export const LeaseTerminationWebApiHandler_getTerminationReasons = (client = getClient()) => {
  return httpFrontEndRequest<never, never, GetTerminationReasonsResponseDto>(
    {
      endpoint: LeaseTerminationWebApiHandler_getTerminationReasons_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};

export const LeaseTerminationWebApiHandler_terminateLease_Path = '/api/web/v1/termination/terminateLease';

/**
 * terminate active lease
 */
export const LeaseTerminationWebApiHandler_terminateLease = (
  postData: TerminateLeaseRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, TerminateLeaseRequestDto, void>(
    {
      endpoint: LeaseTerminationWebApiHandler_terminateLease_Path,
      method: 'POST',
      contextPath: '/leasing',
      postData: postData,
    },
    client,
  );
};
